import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface CheckIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const CheckIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: CheckIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M5 12.2486L8.302 16.3762C8.6744 16.8416 9.3686 16.8799 9.79 16.4585L19 7.24855"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default CheckIcon
